import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import {setCurrentStep, resetWorkOrderData} from '../BusinessWorkOrderSystemSlice';
import {BusinessWorkOrderSystemStep} from '../Constant/Constant';
import successIcon from '../Icons/success.svg';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import BtnWhite from 'app/Components/Shared/Buttons/BtnWhite';
import { formatDateString14digits } from 'app/utilities/StringHelpers/StringHelpers';

const WorkOrderCreationSuccedded = ({setCurrentStep , businessWorkOrderSystem , workOrderCreation , resetWorkOrderData}) => { 
 
 const onFinish = (step) => {
  resetWorkOrderData();
  setCurrentStep(step);
 }


  return (
    <div className='work-order-creation-succeeded'>
        <div><Image src={successIcon} alt='success' /></div>
        <div className='l-title'> פניה מספר {workOrderCreation.workOrderId} נפתחה בהצלחה לצוותון השירות</div>
        <div className='m-title'>הפניה תטופל עד {formatDateString14digits(workOrderCreation.dueDate)}<br/> צוותון שירות  {workOrderCreation.userFullName}</div>
        <div className='m-title'>לרשותך בכל דבר, {window.Config.brand_Name_HE} עסקים</div>
        
      <div className='action-buttons'>
            <BtnSubmit  text='סיום'  onclick={() => onFinish(BusinessWorkOrderSystemStep.Dashboard)} />
            <BtnSubmit  text='פתח פניה נוספת'onclick={() => onFinish(BusinessWorkOrderSystemStep.WorkOrderTypeSelecting)}  />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
    businessWorkOrderSystem: state.businessWorkOrderSystem,
    workOrderCreation: state.businessWorkOrderSystem.WorkOrderCreation,
});
const mapDispatchToProps = {setCurrentStep, resetWorkOrderData};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderCreationSuccedded);
